<app-layout>
  @if (chooseLanguageView) {
    <div primary>
      <h1 class="text-h1 mb-6">
        {{ "language.header" | translate }}
      </h1>
    </div>
  }

  @if (chooseLanguageView && options.length > 0) {
    <div secondary>
      <app-choose-language
        displayVariant="SECONDARY"
        [options]="options"
        (selectedLanguage)="setLanguage($event)"
        [showFlags]="chooseLanguageView.data.showFlags"
        [defaultLanguage]="response.language"
        [translationKeys]="['language.header', 'navigation.']"
        [fallbackLanguage]="response.fallbackLanguage"
        displayAs="list"
      ></app-choose-language>
    </div>
  }
  <app-navigation
    (nextClick)="next()"
    [nextButtonText]="'navigation.next.button' | translate"
    navigation
  ></app-navigation>
</app-layout>
